import Vue from 'vue'
import Config from '@/shared/Config'

export default {
  state: {
    organization_id: null,
    organization: null,
    max: null
  },
  mutations: {
    SET_ORGANIZATION_QUOTAS_ID (state, organizationId) {
      state.organization_id = organizationId
    },
    SET_ORGANIZATION_QUOTAS (state, organization) {
      state.organization = organization
    },
    SET_ORGANIZATION_MAX (state, max) {
      state.max = max
    },
    SET_PROJECT_PREALLOCATIONS (state, project) {
      const organizationProject = state.organization?.projects_quotas?.find(p => p.project_id === project.project_id)
      if (organizationProject) organizationProject.assignPreallocations(project.preallocations)
    }
  },
  actions: {
    async REFRESH_ORGANIZATION_QUOTAS ({ getters, commit }) {
      const config = await Config()
      commit('SET_ORGANIZATION_QUOTAS_ID', config.ORGANIZATION_ID)
      const organization = await Vue.api.QUOTA_MANAGER.organizations.list()
      commit('SET_ORGANIZATION_QUOTAS', organization)
    },
    async REFRESH_ORGANIZATION_MAX ({ getters, commit }) {
      const config = await Config()
      commit('SET_ORGANIZATION_QUOTAS_ID', config.ORGANIZATION_ID)
      const max = await Vue.api.QUOTA_MANAGER.maxQuotas()
      commit('SET_ORGANIZATION_MAX', max)
    },
    async REFRESH_PROJECT_PREALLOCATIONS ({ getters, commit }, projectId) {
      const project = await Vue.api.QUOTA_MANAGER.projects.getOne(projectId)
      commit('SET_PROJECT_PREALLOCATIONS', project)
    }
  },
  getters: {
    ORGANIZATION_QUOTAS_ID (state) {
      return state.organization_id
    },
    ORGANIZATION_QUOTAS (state) {
      return state.organization
    },
    ORGANIZATION_MAX (state) {
      return state.max
    }
  }
}
